// src/components/Magazine/Michelangelo.js
import React, {useState} from 'react';
import CloseIcon from '@mui/icons-material/Close';

import '../../styles/magazineGallery.scss';

function Megan() {
  /*Costruire react things */
    let data=[
        {
            id: 1,
            imgSrc: '/images/MeganDue/MeganDue_1.jpg',
        },
        {
            id: 2,
            imgSrc: '/images/MeganDue/MeganDue_2.jpg',
        },
        {
            id: 3,
            imgSrc: '/images/MeganDue/MeganDue_3.jpg',
        },
        {
            id: 4,
            imgSrc: '/images/MeganDue/MeganDue_4.jpg',
        },
        {
            id: 5,
            imgSrc: '/images/MeganDue/MeganDue_5.jpg',
        },
        {
            id: 6,
            imgSrc: '/images/MeganDue/MeganDue_6.jpg',
        },
        {
            id: 7,
            imgSrc: '/images/MeganDue/MeganDue_7.jpg',
        },
        {
            id: 8,
            imgSrc: '/images/MeganDue/MeganDue_8.jpg',
        },
        {
            id: 9,
            imgSrc: '/images/MeganDue/MeganDue_9.jpg',
        },
        {
            id: 10,
            imgSrc: '/images/MeganDue/MeganDue_10.jpg',
        },
        {
            id: 11,
            imgSrc: '/images/MeganDue/MeganDue_11.jpg',
        },
        {
            id: 12,
            imgSrc: '/images/MeganDue/MeganDue_12.jpg',
        },
        {
            id: 13,
            imgSrc: '/images/MeganDue/MeganDue_13.jpg',
        },
        
    ]
    const [model, setModel] = useState(false);
    const [tempimgSrc, setTempImgSrc] = useState('');
    const getImg = (imgSrc) =>{
        setTempImgSrc(imgSrc);
        setModel(true);
    }
  return (
    <>
    <div className={model ? "model open" : "model"}>
        <img src={tempimgSrc} alt="Ria Megan" />
        <CloseIcon onClick={()=> setModel(false)} />
    </div>
        <div className="gallery">
            {data.map((item, index)=>{
                return(
                    <div className='pics' key={index} onClick={()=> getImg(item.imgSrc)}>
                        <img src={item.imgSrc} alt="Ria Megan" style={{width: '100%'}} loading="lazy"/>
                    </div>
                )
            })}
        </div>
     
    </>
  );
}

export default Megan;
